export interface LicenseListData {
  contractId?: string;
  licensedTo?: string;
  licensedToCompanyName: string;
  application: number;
  fromTo: string[];
  machineKey?: string;
  licenseType: string;
  numBasicRobot?: number;
  numPremiumRobot?: number;
  numFloatingRobot?: number;
  numStudio?: number;
  numFloatingStudio?: number;
  numPdfImage?: number;
  numPdfText?: number;
  numVicode?: number;
  note?: string;
  deploymentType?: number;
  applySource?: number;
  callbackEmail?: string;
}

export interface LicenseListViewJust {
  licensedToCompanyName?: string;
  licensesCount?: number;
  lastCreateTime?: string;
}

export interface LicenseListViewNested {
  id: number;
  contractId?: string;
  licensedTo?: string;
  licensedToCompanyName?: string;
  requestedBy?: string;
  createBy?: string;
  licenseType?: string;
  notBefore?: string;
  notAfter?: string;
  application?: number;
  createTime?: string;
  applySource?: number;
}

export interface LicenseListView extends LicenseListViewJust {
  licenseDataList?: LicenseListViewNested[];
}

export interface LicenseListDetail {
  id: number;
  contractId?: string;
  licensedTo?: string;
  licensedToCompanyName?: string;
  requestedBy?: string;
  createBy?: string;
  licenseType?: string;
  notBefore?: string;
  notAfter?: string;
  application?: number;
  machineKey?: string;
  createTime?: string;
  note?: string;
  licenseStrs?: string;
  licenseProducts?: LicenseProducts[];
}

export interface LicenseProducts {
  name?: string;
  amount?: number;
  sku?: string;
}

export enum UserAuthoritiyEnum {
  CompanyManage = "CompanyManage",
  LicenseManage = "LicenseManage",
}
